import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import ToolTipComp from "./ToolTip";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function AssessmentAccordion({
  groups = [],
  renderItem,
  onGroupEdit,
  onGroupView,
  onGroupSelect,
  user,
}) {
  const [show, setShow] = useState([]);
  const [edit, setEdit] = useState([]);
  return (
    <Accordion className="assessment-accordion">
      {groups.map((group, idx) => (
        <Accordion.Item eventKey={String(idx)} key={group.id || idx}>
          <Accordion.Header>
            <div className="d-flex w-100 justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                {onGroupSelect && (
                  <input
                    type="checkbox"
                    className={`school-checkbox me-3 form-check-input`}
                    checked={group.selected || false}
                    onChange={(e) => {
                      e.stopPropagation();
                      onGroupSelect(group);
                    }}
                  />
                )}
                <div>
                  <strong>
                    {group.title
                      ? //   ? new Date(group.title).toLocaleString()
                        group.title
                      : `Group ${idx + 1}`}
                  </strong>
                  <div className="small text-muted">
                    {group.allItems?.length || group.items?.length || 0} item(s)
                  </div>
                </div>
              </div>
              <div className="me-3">
                {onGroupEdit && user.UserTypeID === 5 ? (
                  <ToolTipComp
                    myButton={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        viewBox="0 0 24 24"
                        width="20px"
                        fill={edit[idx] ? "#18a587" : "#505050"}
                        onMouseEnter={() =>
                          setEdit((prev) => {
                            const next = [...prev];
                            next[idx] = true;
                            return next;
                          })
                        }
                        onMouseLeave={() =>
                          setEdit((prev) => {
                            const next = [...prev];
                            next[idx] = false;
                            return next;
                          })
                        }
                        className="cursor-pointer me-2"
                        onClick={(e) => {
                          e.stopPropagation();
                          onGroupEdit(group);
                        }}
                      >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                      </svg>
                    }
                    type="Edit"
                    module="Assessment"
                  />
                ) : null}

                {onGroupView && (
                  <ToolTipComp
                    myButton={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        enable-background="new 0 0 24 24"
                        height="20px"
                        viewBox="0 0 24 24"
                        width="20px"
                        fill={show[idx] ? "#18a587" : "#505050"}
                        onMouseEnter={() =>
                          setShow((prev) => {
                            const next = [...prev];
                            next[idx] = true;
                            return next;
                          })
                        }
                        onMouseLeave={() =>
                          setShow((prev) => {
                            const next = [...prev];
                            next[idx] = false;
                            return next;
                          })
                        }
                        className="cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          onGroupView(group);
                        }}
                      >
                        <g>
                          <path d="M0,0h24v24H0V0z" fill="none" />
                        </g>
                        <g>
                          <g>
                            <path d="M15,3H5C3.9,3,3.01,3.9,3.01,5L3,19c0,1.1,0.89,2,1.99,2H19c1.1,0,2-0.9,2-2V9L15,3z M5,19V5h9v5h5v9H5z M9,8 c0,0.55-0.45,1-1,1S7,8.55,7,8s0.45-1,1-1S9,7.45,9,8z M9,12c0,0.55-0.45,1-1,1s-1-0.45-1-1s0.45-1,1-1S9,11.45,9,12z M9,16 c0,0.55-0.45,1-1,1s-1-0.45-1-1s0.45-1,1-1S9,15.45,9,16z" />
                          </g>
                        </g>
                      </svg>
                    }
                    type="Show"
                    module="Assessment"
                  />
                )}
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <Row>
              <Col xs={12}>
                {group.items && group.items.length > 0 ? (
                  group.items.map((item) => (
                    <div key={item.AssessmentID}>{renderItem(item)}</div>
                  ))
                ) : (
                  <div className="text-center text-muted">
                    No items in this page slice.
                  </div>
                )}
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

export default AssessmentAccordion;
